import PropTypes from 'prop-types';
import { states2char } from '../util/stateUtil.mjs';

const ValidationShape = PropTypes.shape({
  type: PropTypes.oneOf([
    'required',
    'between',
    'postalCode',
    'phoneNumber',
    'emailAddress'
  ]).isRequired,
  min: PropTypes.number,
  max: PropTypes.number
});

const ValueShape = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.string),
  PropTypes.bool,
  PropTypes.number,
]);

const AnswerShape = PropTypes.shape({
  appkey: PropTypes.string.isRequired,
  value: ValueShape.isRequired,
  timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])
});

const AnswerViewShape = PropTypes.shape({
  key: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]).isRequired,
  attributes: PropTypes.object
});

const QuestionShape = PropTypes.shape({
  appkey: PropTypes.string.isRequired,
  attributes: PropTypes.object,
  answers: PropTypes.arrayOf(AnswerViewShape),
  type: PropTypes.string.isRequired,
  validations: PropTypes.arrayOf(ValidationShape)
});

const BuilderLinkedQuestionsShape = PropTypes.shape({
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  questions: PropTypes.arrayOf(QuestionShape).isRequired
});

const BuilderConnectedPropTypes = {
  builderLinkedQuestions: PropTypes.arrayOf(BuilderLinkedQuestionsShape).isRequired,
  builderOptions: QuestionShape.isRequired,
  renderLinkedQuestion: PropTypes.func.isRequired
};

const LocationShape = PropTypes.shape({
  id: PropTypes.any,
  lat: PropTypes.number,
  lng: PropTypes.number,
  name: PropTypes.string,
  address: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.oneOf(states2char),
  postalCode: PropTypes.string
});

const MessageDefinitionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string.isRequired
});

const ProgressReviewField = PropTypes.shape({
  title: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired
});

const BranchShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

const EmployeeShape = PropTypes.shape({
  id: PropTypes.string,
  customerId: PropTypes.string,
  businessId: PropTypes.string,
  businessDba: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  branches: PropTypes.arrayOf(BranchShape)
});

const LoginFlowScreenPropTypes = {
  changeScreen: PropTypes.func,
  loginFlowChanged: PropTypes.func.isRequired,
  processing: PropTypes.bool,
  onCancel: PropTypes.func
};

const QuestionGroupViewPropTypes = {
  className: PropTypes.string,
  page: PropTypes.any,
  questionGroup: PropTypes.any,
  renderQuestion: PropTypes.func,
  renderChildren: PropTypes.func,
};

const QuestionTypeViewPropTypes = {
  className: PropTypes.string,
  question: QuestionShape,
  value: PropTypes.oneOfType([
    AnswerShape,
    ValueShape
  ]),
  valueChanged: PropTypes.func,
};


export {
  AnswerShape,
  AnswerViewShape,
  BuilderConnectedPropTypes,
  LoginFlowScreenPropTypes,
  BranchShape,
  EmployeeShape,
  LocationShape,
  MessageDefinitionShape,
  ProgressReviewField,
  QuestionShape,
  QuestionGroupViewPropTypes,
  QuestionTypeViewPropTypes,
  ValidationShape,
  ValueShape
};
